import { Input } from "antd";
import * as React from "react";
import { BaseFormItem, FieldValues, IBaseFormItem } from "../BaseFormItem";
import { InputProps } from "antd/es/input";

interface IProps<TFieldValues extends FieldValues>
    extends IBaseFormItem<TFieldValues>,
        Omit<InputProps, "name"> {}

export const FormInputItem = <TFieldValues extends FieldValues = FieldValues>(
    props: IProps<TFieldValues>
) => {
    return (
        <BaseFormItem<TFieldValues>
            name={props.name}
            label={props.label}
            formItemProps={props.formItemProps}
            render={(field) => <Input {...props} {...field} />}
        />
    );
};
